export default __webpack_public_path__ + "static/media/cup.57c05a4d.svg";